import { backendApi } from "../base.config";

export const systemMessagesApi = backendApi.injectEndpoints({
    endpoints: (builder) => ({
        getValueMessage: builder.query({
            query: () => ({
                url:`customerTestRun/getValueNonValueMessageType`,
                method:'GET',
            }),
        }),
        // getValueNonValueMessage: builder.query({
        //     query: (args) => ({
        //         method:'GET',
        //         url:`customerTestRun/getValueNonValueMessages`,
        //         params:{...args}
        //     }),
        //     providesTags: [],
        // })
        getValueNonValueMessage: builder.query({
            query: (args) => {
            const params = {
            };

            if (args?.messageType) {
              params.messageType = args.messageType;
            }
            if (args?.paymentServiceId) {
              params.paymentServiceId = args.paymentServiceId;
            }
            return {
              url: `customerTestRun/getValueNonValueMessages`,
              method: 'GET',
              params
            };
            },
            providesTags: []
          }),
    })
});

export const {
    useGetValueMessageQuery,
    useGetValueNonValueMessageQuery,
} = systemMessagesApi